export const gaCategoryMap = {
  vehicle_report: 'vehicle monitor',
  property_report: 'property monitor',
  social_network_report: 'email monitor',
  reverse_phone_report: 'phone monitor',
  detailed_person_report: 'name monitor',
  username_report: 'social media monitor',
};
